// extracted by mini-css-extract-plugin
module.exports = {"root":"Balance_root__6izR4","wrapper":"Balance_wrapper__QUkJh","balance":"Balance_balance__liecs","add":"Balance_add__THcDJ"};